import { firstValueFrom } from 'rxjs';
import { ComponentDataSourceService } from '../../../services/component-data-source/component-data-source.service';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { UserGroupDTO } from '../../../dto/user-group/user-group.dto';
import {
  isGroupsHideEmptyAtLocationEnabled,
  resolveOrgIdFromUser,
} from './user-groups-location-display.util';

const LOCATION_GROUPS_LIST_PAGE_SIZE = 10000;

export async function fetchLocationUserGroupsWithSettings(
  service: ComponentDataSourceService,
  locationGuid: string
): Promise<{ hideEmptyAtLocation: boolean; groups: UserGroupDTO[] }> {
  const user = service.authService.getCurrentUser() as Record<
    string,
    unknown
  > | null;
  const orgId = resolveOrgIdFromUser(user);

  let hideEmptyAtLocation = true;
  if (orgId != null) {
    try {
      const settingsRes = await firstValueFrom(
        service.executeDataSource('org_settings', { organizationId: orgId })!
      );
      const data =
        (settingsRes as { data?: Record<string, unknown> })?.data ?? {};
      hideEmptyAtLocation = isGroupsHideEmptyAtLocationEnabled(data);
    } catch {
      hideEmptyAtLocation = true;
    }
  }

  let groups: UserGroupDTO[] = [];
  try {
    const listParams = {
      filters: [
        {
          column: 'pageSize',
          value: LOCATION_GROUPS_LIST_PAGE_SIZE,
          operator: 'eq',
        },
        { column: 'pageIndex', value: 0, operator: 'eq' },
      ],
    } as LoadDataParams;
    const result = await firstValueFrom(
      service['loadDataWithStandardFiltersGET'](
        'duna_user_groups_location',
        `/user-groups/by-location/${locationGuid}`,
        listParams
      )
    );
    groups = ((result?.items ?? []) as UserGroupDTO[]) || [];
  } catch {
    groups = [];
  }

  return { hideEmptyAtLocation, groups };
}
